import {Component, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PdfJsViewerComponent} from 'ng2-pdfjs-viewer';
import {SessionStorage} from '../../../../global/util/SessionStorage';

@Component({
  selector: 'app-preview-template',
  templateUrl: './preview-template.component.html',
  styleUrls: ['./preview-template.component.css']
})
export class PreviewTemplateComponent implements OnInit {
  type = 'preview';
  pdfSrc: any;
  @ViewChild('pdfViewer') public pdfViewer: PdfJsViewerComponent;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.pdfSrc = SessionStorage.getUrlPdf();
      this.pdfViewer.pdfSrc = this.pdfSrc;
      this.pdfViewer.refresh();
    }, 1000);
  }

  accept() {
    this.activeModal.close();
  }
}
